
import {helpers} from '@/ft-vue-core'

const {deepClone} = helpers

export const dataDefaults = {
  defaultMaxPartySize: 8,
  maxPartySize: 8,
  showAddMultipleDialog: false,
  showCancelReservationDialog: false,
  addMultipleCount: null,
  detailWarnings: [],
  memberFilterSelections: {group: null, mType: null, mShip: null},
  lastActiveInput: null,
  reservationNotificationMode: null,
  forceEvent: false,
  forceMealPeriod: false,
  reservationType: null,
  showCancelledReservees: false,
  showConfirmationDetails: false,
  originalCalledAt: false,
  blockMemberEdit: false
}

export const detailDefault = {
  reservationId: null,
  eventCostId: null,
  memberId: null,
  guestId: null,
  guestTypeId: null,
  guestHostId: null,
  name: null,
  notes: null,
  checkNumber: 1,
  pos: 0,
  show: null,
  billTo: false,
  cancelled: null,
  isPlaceholder: true,
  cancelledByMemberId: null,
  cancelledByStaffId: null,
  cancellationReasonId: null,
  cancelFeeExempt: null,
  cancellationNotes: null,
  origByMemberId: null,
  origByStaffId: null,
  answers: []
}

export const itemDefault = {
  id: null,
  eventId: null,
  mealPeriodId: null,
  mealPeriodName: null,
  locationId: null,
  reservationStateId: 1, // Holding
  isPlaceHolder: null,
  occasionId: null,
  numberOfChecks: 1,
  date: null,
  time: null,
  cancelled: null,
  cancelledByMemberId: null,
  cancelledByStaffId: null,
  cancellationReasonId: null,
  cancelFeeExempt: false,
  cancellationNotes: null,
  notes: null,
  specialRequests: null,
  memberSpecialRequests: null,
  calledBackAt: null,
  calledBackByStaffId: null,
  confirmationStatusId: null,
  confirmationNotes: null,
  sendEmails: false,
  walkIn: false,
  lottery: false,
  waitlist: false,
  tableNumber: null,
  recordLockKey: null,
  recordLockExpiration: null,
  origMemberId: null,
  origStaffId: null,
  covers: null,
  tableAssignments: [],
  answers: [],
  discreteCovers: true,
  details: [deepClone(detailDefault)],
  cancelledDetails: []
}

export const defaultSearchFilter = {
  date: null,
  eventName: null,
  mealPeriodIds: [],
  guestTypeId: null,
  memberId: null,
  locationId: null,
  guestSearch: null,
  confirmationStatusId: null,
  cancelled: false,
  reservationNumber: null,
  origByField: null,
  listingSortOrderId: null,
  eventCostName: null,
  showMode: null, // To be used for showing any (null), event only ('event'), dining only ('dining')
  days: {
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false
  },
  columns: {
    dateTime: true,
    locationName: true,
    eventName: true,
    details: true,
    confirmationStatus: true,
    covers: true,
    tableAssignments: true,
    issues: false,
    created: false
  }
}
